__turbopack_context__.v({
  "cell": "K_1Imq_cell",
  "facet-reveal": "K_1Imq_facet-reveal",
  "facetValue": "K_1Imq_facetValue",
  "grid": "K_1Imq_grid",
  "icon": "K_1Imq_icon",
  "label": "K_1Imq_label",
  "link": "K_1Imq_link",
  "more": "K_1Imq_more",
  "text": "K_1Imq_text",
  "value": "K_1Imq_value",
});
